import {
  DispatchTypes,
  BuildingStatuses,
  BuildingTypes,
} from "./buildingDropdownConfig";

export const buildingGeneralFields = [
  { key: "buildingReference", label: "Building Site", type: "text" },
  { key: "buildingName", label: "Building Name", type: "text" },
  { key: "managementID", label: "Management Company", type: "text" },
  { key: "customerID", label: "Customer", type: "text" },
  { key: "salesRep", label: "Sales Rep", type: "text" },
];

export const buildingComment = [
  { key: "buildingNote", label: "Building Notes", type: "textArea" },
];

export const buildingAddressFields = [
  { key: "addressCareOf", label: "Address Care Of", type: "text" },
  { key: "addressLine1", label: "Address Line 1", type: "text" },
  { key: "addressLine2", label: "Address Line 2", type: "text" },
  { key: "city", label: "City", type: "text" },
  { key: "state", label: "State", type: "text" },
  { key: "zipCode", label: "Zip Code", type: "text" },
];

export const buildingBillingAddressFields = [
  {
    key: "billingAddressCareOf",
    label: "Billing Address Care Of",
    type: "text",
  },
  { key: "billingAddressLine1", label: "Billing Address Line 1", type: "text" },
  { key: "billingAddressLine2", label: "Billing Address Line 2", type: "text" },
  { key: "billingCity", label: "Billing City", type: "text" },
  { key: "billingState", label: "Billing State", type: "text" },
  { key: "billingZipCode", label: "Billing Zip Code", type: "text" },
];

export const buildingAdditionalFields = [
  {
    key: "dispatchType",
    label: "Dispatch Type",
    type: "select",
    options: DispatchTypes,
  },
  {
    key: "buildingStatus",
    label: "Status",
    type: "select",
    options: BuildingStatuses,
  },
  {
    key: "buildingType",
    label: "Building Type",
    type: "select",
    options: BuildingTypes,
  },
  { key: "agencyID", label: "Agency", type: "text" },
  { key: "taxDetailID", label: "Tax Detail", type: "text" },
];

export const contactRoles = [
  { roleKey: "mainContact", roleLabel: "Main Contact" },
  { roleKey: "agentContact", roleLabel: "Agent Contact" },
  { roleKey: "superintendentContact", roleLabel: "Superintendent Contact" },
  { roleKey: "collectionsContact", roleLabel: "Collections Contact" },
  { roleKey: "dobContact", roleLabel: "DOB Contact" },
];

export const contactGeneralFields = [
  { key: "contactName", label: "Name" },
  { key: "contactTitle", label: "Title" },
  { key: "description", label: "Description" },
  { key: "emailAddress", label: "Email" },
  { key: "phone1", label: "Main Phone", type: "phone" },
  { key: "cellPhone", label: "Cell Phone", type: "phone" },
];

export const contactAdditionalFields = [
  { key: "emailAddress2", label: "Secondary Email" },
  { key: "phone2", label: "Secondary Phone", type: "phone" },
  { key: "cellPhone2", label: "Secondary Cell", type: "phone" },
  { key: "faxNumber", label: "Fax Number", type: "phone" },
];

export const initialContactFormData = {
  contactName: "",
  emailAddress: "",
  phone1: "",
  phone2: "",
  faxNumber: "",
  description: "",
  contactTitle: "",
  cellPhone: "",
  cellPhone2: "",
  emailAddress2: "",
};
